export default {
    page_title: "Kevi | Formularios",
    manage_title: "Gestionar Formularios",
    new_btn: "Nuevo Formulario",
    max_reached: "Ha alcanzado el máximo de {0} formularios",
    modal_rename_title: "Renombrar Formulario",
    modal_add_title: "Agregar Formulario",
    name_label: "Nombre:",
    btn_add: "Agregar",
    btn_save: "Guardar",
    confirm_delete_question: "¿Está seguro de que desea eliminar el Formulario",
    confirm_delete_body: "Después de la eliminación, la acción será irreversible.",
    confirm_duplicate_question: "¿Está seguro de que desea duplicar el Formulario",
    confirm_duplicate_body: "Después de la duplicación, el formulario se creará con el mismo nombre.",
    answers: "respuestas",
    tooltip_manage: "Gestionar Preguntas",
    tooltip_view: "Ver Formulario",
    tooltip_view_tab: "Ver Formulario en nueva pestaña",
    tooltip_report: "Reporte de Respuestas",
    tooltip_export: "Exportar Respuestas",
    tooltip_duplicate: "Duplicar Formulario",
    tooltip_rename: "Renombrar Formulario",
    tooltip_remove: "Eliminar Formulario",
    notification_duplicated: "¡Formulario duplicado con éxito!",
    notification_deleted: "Formulario eliminado con éxito.",
    notification_saved: "Formulario guardado con éxito.",
    notification_reset: "Formulario restablecido con éxito.",
    btn_cancel: "Cancelar",
    count_forms: "{0} formularios",
    search_placeholder: "Buscar formulario",
    questions_count: "{0} preguntas",
    answers_count: "{0} respuestas",
    action_questions: "Preguntas",
    action_answers: "Respuestas",
    action_copy_link: "Copiar enlace público",
    link_copied: "Enlace copiado al portapapeles.",
    more_actions: "Más acciones",
    empty_title: "Aún no hay formularios",
    empty_subtitle: "Cree su primer formulario para empezar a recibir respuestas.",
    empty_search: "Ningún formulario coincide con esta búsqueda.",
    settings: {
        title: "Datos del cliente",
        subtitle: "Elija qué datos pide el formulario antes de enviar las respuestas.",
        field_askName: "Nombre",
        field_askLastName: "Apellido",
        field_askEmail: "Correo electrónico",
        field_askPhone: "Teléfono",
        field_askBirthdate: "Fecha de nacimiento",
        ask_no: "No pedir",
        ask_optional: "Opcional",
        ask_required: "Obligatorio",
        btn_save: "Guardar datos",
        notification_saved: "Configuración del formulario guardada.",
    },
    appearance: {
        tooltip: "Configuración del formulario",
        title: "Configuración del formulario",
        subtitle: "Elija la posición de los datos del cliente y el mensaje de éxito.",
        position_label: "Posición de los datos del cliente",
        position_below: "Debajo de las preguntas",
        position_above: "Encima de las preguntas",
        success_title_label: "Título de éxito",
        success_title_placeholder: "¡Gracias!",
        success_message_label: "Mensaje de éxito",
        success_message_placeholder: "¡Tu opinión es muy importante!",
        btn_save: "Guardar configuración",
        notification_saved: "Configuración del formulario guardada.",
    },
    questions: {
        title: "Formulario",
        list_title: "Preguntas",
        count: "{0} preguntas",
        answers_count: "{0} respuestas",
        empty_title: "Aún no hay preguntas",
        empty_subtitle: "Agregue la primera pregunta para armar su formulario.",
        open_public: "Abrir formulario",
        btn_back: "Volver",
        btn_add_question: "Agregar Pregunta",
        pending_changes: "Tiene cambios pendientes.",
        leave_unsaved: "Tiene cambios pendientes. Si sale ahora, se perderán. ¿Desea continuar?",
        revert_changes: "Revertir cambios",
        btn_save: "Guardar",
        conditional: "Pregunta condicional",
        answers: "respuestas",
        new_question: "Nueva pregunta",
        will_remove: "Esta pregunta será eliminada al guardar",
        view_answers: "Ver Respuestas",
        tooltip_condition: "Agregar Condición",
        tooltip_delete: "Eliminar pregunta",
        copy_id: "Copiar ID de la pregunta",
        id_copied: "ID de la pregunta copiado",
        tooltip_edit: "Editar pregunta",
        tooltip_undo: "Deshacer eliminación",
        type_emotion: "Escala emocional (CSAT)",
        type_comment: "Respuesta abierta",
        type_boolean: "Sí o no",
        type_selectbox: "Opción múltiple",
        type_input: "Texto corto",
        type_nps: "Métrica NPS",
        type_date: "Fecha",
        type_ces: "Métrica CES",
        type_file: "Archivo",
        type_content: "Texto explicativo",
        type_emotion_hint: "Nota de 1 a 5 con caritas.",
        type_comment_hint: "Campo abierto para textos largos.",
        type_boolean_hint: "Respuesta binaria de sí o no.",
        type_selectbox_hint: "Lista de opciones para elegir.",
        type_input_hint: "Campo de texto de una línea.",
        type_nps_hint: "Nota de recomendación de 0 a 10.",
        type_date_hint: "Selección de una fecha en el calendario.",
        type_ces_hint: "Nota de esfuerzo de 1 a 7.",
        type_file_hint: "Subida de imágenes y documentos.",
        type_content_hint: "Bloque de texto con formato, sin respuesta.",
    },
    report: {
        page_title: "Kevi | Reporte de Respuestas",
        title: "Reporte de Respuestas",
        btn_export: "Exportar",
        no_answers_found: "No se encontraron respuestas",
        no_answers_description: "¿Ya comenzó a difundir su nuevo programa de fidelidad? No reciba mañana la opinión que puede recibir hoy.",
        segment_filter: "Segmento del cliente",
    },
    questions_form: {
        close: "Cerrar",
        select_type_title: "Seleccione el tipo de pregunta",
        back: "Volver",
        fill_data_title: "Complete los datos de la pregunta",
        edit_title: "Editar pregunta",
        type_locked: "(no se puede cambiar)",
        remove_option: "Eliminar opción",
        undo_remove_option: "Deshacer eliminación de la opción",
        content_label: "Contenido mostrado en el formulario",
        content_hint: "Seleccione el texto para darle formato con títulos, negrita, cursiva y listas.",
        placeholder_content: "Cuente aquí lo que el cliente necesita saber antes de responder.",
        error_content: "Escriba el contenido que se mostrará en el formulario",
        impact_hint: "Esta pregunta ya tiene {0} respuestas. Cambiar el texto o las opciones cambia cómo aparecen en los informes.",
        impact_title: "Este cambio afecta a informes anteriores",
        impact_body: "Esta pregunta ya fue respondida {0} veces.",
        impact_body_extra: "Las respuestas ya registradas se mostrarán con el nuevo texto y las nuevas opciones en todos los informes y exportaciones.",
        impact_confirm: "Cambiar de todos modos",
        type_label: "Tipo:",
        question_text_label: "Texto de su pregunta:",
        multiselect_label: "Selección múltiple",
        multiselect_hint: "Permite selección múltiple entre las opciones propuestas.",
        options_label: "Opciones:",
        option_will_remove: "Esta opción será eliminada al guardar",
        btn_add_option: "Nueva Opción",
        btn_save_question: "Guardar Pregunta",
        btn_add_question: "Agregar Pregunta",
        error_question: "Debe especificar el texto de la pregunta correctamente",
        error_options: "Debe especificar al menos dos opciones para la lista, además de completar todas correctamente con un mínimo de dos caracteres.",
        placeholder_default: "¿Cómo estaba la comida?",
        placeholder_selectbox: "¿Cómo conoció nuestros servicios?",
        placeholder_date: "Día en que nos visitó",
        placeholder_file: "Envíe el arte o el logo de su empresa",
        placeholder_option: "Opción {0}",
        file_multiple_label: "Permitir múltiples archivos",
        file_multiple_hint: "Permite que el cliente envíe más de un archivo en esta pregunta.",
        file_max_files_label: "Máximo de archivos:",
        file_types_label: "Tipos de archivo aceptados:",
        file_types_any: "Cualquier tipo permitido por Kevi",
        file_types_image: "Solo imágenes",
        file_types_image_dst: "Imágenes o bordado (.DST)",
        file_types_dst: "Solo bordado (.DST)",
        file_formats_hint: "El límite global es de 30 MB por archivo.",
    },
    report_component: {
        answers: "respuestas",
        general_assessment: "Evaluación general",
        no_answers: "Por ahora nadie respondió esta pregunta.",
        see_all_answers: "Ver respuestas completas",
        grade_very_good: "Muy bueno",
        grade_good: "Bueno",
        grade_neutral: "Neutro",
        grade_bad: "Malo",
        grade_very_bad: "Muy malo",
        boolean_yes: "Sí",
        boolean_no: "No",
        nps_promoter: "Promotor",
        nps_neutral: "Neutro",
        nps_detractor: "Detractor",
        ces_label_1: "Extremadamente difícil",
        ces_label_2: "Muy difícil",
        ces_label_3: "Difícil",
        ces_label_4: "Aceptable",
        ces_label_5: "Fácil",
        ces_label_6: "Muy fácil",
        ces_label_7: "Extremadamente fácil",
        selectbox_view: "Visualizar",
        selectbox_list: "Lista",
        selectbox_chart: "Gráfico",
    },
    conditions: {
        modal_title: "Condiciones de visualización",
        header_text: "Use las condiciones para crear formularios dinámicos y personalizados, permitiendo controlar la visibilidad de las preguntas según las respuestas proporcionadas en preguntas anteriores (por eso, la primera pregunta no puede tener condiciones).",
        no_previous_warning: "La primera pregunta no puede tener condiciones, ya que no hay preguntas anteriores en las que basar la condición.",
        btn_cancel: "Cancelar",
        btn_confirm: "Confirmar",
        error_fill_all: "Por favor, complete todos los campos de las condiciones antes de guardar.",
        operator_label: "Operador:",
        operator_and: "Y (todas las condiciones)",
        operator_or: "O (cualquier condición)",
        btn_add_condition: "Agregar Condición",
        btn_add_group: "Agregar Grupo",
        remove_condition: "Eliminar condición",
        remove_group: "Eliminar grupo",
        empty_message: "Agregue condiciones o grupos para construir su lógica",
        condition_label: "Condición",
        question_label: "Pregunta",
        select_placeholder: "Seleccione...",
        operator_select_label: "Operador",
        value_label: "Valor",
        value_placeholder: "Ingrese el valor",
        emotion_1: "1 - Muy Insatisfecho",
        emotion_2: "2 - Insatisfecho",
        emotion_3: "3 - Neutral",
        emotion_4: "4 - Satisfecho",
        emotion_5: "5 - Muy Satisfecho",
        boolean_yes: "Sí",
        boolean_no: "No",
        op_equal: "Igual a",
        op_not_equal: "Diferente de",
        op_greater_than: "Mayor que",
        op_greater_than_or_equal: "Mayor o igual que",
        op_less_than: "Menor que",
        op_less_than_or_equal: "Menor o igual que",
        op_includes: "Contiene",
        op_answered: "Respondida",
    },
    embed: {
        title: "Usar este formulario en mi sitio",
        subtitle: "Copie el código para mostrar el formulario en su página o enviar las respuestas desde su propio formulario.",
        tab_link: "Enlace directo",
        tab_iframe: "Vía iframe",
        tab_js: "Integración vía código",
        copy: "Copiar",
        copied: "Copiado",
        copied_toast: "Código copiado",
        link_help: "Use este enlace para abrir el formulario en una página propia, WhatsApp, correo u otro canal.",
        iframe_lead: "Poco técnico y funciona rápido: ideal para poner el formulario Kevi en el sitio con poca personalización.",
        sdk_step: "1. Instale el SDK de Kevi",
        sdk_help: "Coloque este código en Google Tag Manager o en el <head> de su sitio. Ajusta la altura del iframe y avisa cuando se envíe el formulario.",
        sdk_snippet_label: "SDK de Kevi",
        iframe_step: "2. Pegue el iframe en la página",
        iframe_help: "Después del SDK, pegue este código en el HTML donde deba aparecer el formulario.",
        iframe_snippet_label: "Código del iframe",
        js_lead: "Personalización total: conecte Kevi a un formulario 100% de su sitio, con su UI y sus reglas.",
        js_help: "Envíe las respuestas de su formulario a Kevi con este código. Los IDs de abajo son de este formulario.",
        js_snippet_label: "Código JavaScript",
        js_note_omit: "Omita del payload las preguntas que el visitante no respondió.",
        js_note_validate: "La validación de campos obligatorios queda en su sitio: la API acepta envíos parciales.",
        js_note_response: "En caso de éxito la API devuelve answer, coupon y client. Si usa el SDK, puede pasar client a kevi.setClient().",
        questions_title: "Preguntas e IDs",
        questions_help: "Use estos IDs como claves en steps_questions. Haga clic en el ID para copiarlo.",
        questions_empty: "Guarde el formulario con al menos una pregunta para generar el código con IDs.",
        format_emotion: "Número del 1 al 5",
        format_nps: "Número del 0 al 10",
        format_ces: "Número del 1 al 7",
        format_boolean: "\"1\" (sí) o \"0\" (no)",
        format_selectbox: "Array con el texto de las opciones",
        format_input: "Texto",
        format_comment: "Texto",
        format_date: "Fecha en formato YYYY-MM-DD",
        format_file: "Array de archivos {url, name, type, size} después de POST /form/{id}/upload",
    },
};
